<template>

    <div class="checklist-maker-step-1">

        <b-form validated horizontal>

            <b-form-group label="Select a Checklist Type">
                <b-form-select required
                               v-model="docData.checklistType"

                               :options="getOptions()">
                </b-form-select>
                <b-alert show v-if="formerType" variant="info">
                    Changing the checklist type clears all existing checklist items. <br/> Is this OK, or would you like to undo this action? <br/>
                    <b-btn class="mt-3" @click="changeTypeOk()">
                        OK
                    </b-btn>
                    <b-btn class="mt-3 ml-2" @click="undoChangeType()">
                        Undo
                    </b-btn>
                </b-alert>


            </b-form-group>

        </b-form>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "ChecklistMakerStep1",
    mixins: [ToolMixin],

    data() {
      return {
          formerTypeItems: [],
          formerType: null
        }
    },
    methods: {
        getOptions() {
            let options = []
            _.each(this.config.checklistMaker.checklistTypes, (type, index) => {
                options.push({value: index + 1, text: type.title})
            })
            return options
        },
        clearItems() {
          this.docData.checklistItems = []
          console.log("clear items")
        },
        changeTypeOk() {
            this.formerTypeItems = []
            this.formerType = null
            console.log("done with changeTypeOk")
            console.log(this.docData.checklistItems)
        },
        undoChangeType() {
            this.docData.checklistType = this.formerType
            this.docData.checklistItems = this.formerTypeItems
            console.log("done with undoChangeType")
            console.log(this.docData.checklistItems)
        }
    },
    computed: {
        thisStepIsValid() {
            return this.docData.checklistType
        },
    },
    watch: {
        'docData.checklistType'(newVal, oldVal) {
            if (!this.formerType && this.docData.checklistType) {
                this.formerType = oldVal
                Vue.set(this.docData, 'checklistType', newVal)
                Vue.set(this.docData, 'checklistItems', [])
            }
            else if (this.formerType === this.docData.checklistType) {
                this.formerType = null
            }
        },
        'docData.checklistItems'(newVal, oldVal) {
            console.log("checklistItems watcher")
            if (this.formerTypeItems.length === 0) {
                this.formerTypeItems = oldVal
                Vue.set(this.docData, 'checklistItems',  newVal)
            }
            else if (this.formerType === this.docData.checklistType) {
                this.formerTypeItems = []
            }
        }
    },
})

</script>
